// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"384":"ed86b127","492":"d2e2019d","973":"dda7a0fd"}[chunkId] + ".css";
};